const items = [
  { label: '주원료처리공정(PU-01)', value: 'PU-01' },
  { label: '부원료처리공정(PU-02)', value: 'PU-02' },
  { label: '부원료보관장 입고공정(PU-02-01)', value: 'PU-02-01' },
  { label: '전기로부원료 처리공정(PU-02-02)', value: 'PU-02-02' },
  { label: '정련로부원료처리공정(PU-02-03)', value: 'PU-02-03' },
  { label: '용수정수공정(PU-03)', value: 'PU-03' },
  { label: '간접냉각수처리공정(PU-04)', value: 'PU-04' },
  { label: '형강제강간접수처리공정(PU-04-01)', value: 'PU-04-01' },
  { label: '형강 연주·압연 간접수처리공정(PU-04-02)', value: 'PU-04-02' },
  { label: '봉강압연간접수처리공정(PU-04-03)', value: 'PU-04-03' },
  { label: '사용물질저장공정(PU-05)', value: 'PU-05' },
  { label: '형강폐수처리약품공정(PU-05-01)', value: 'PU-05-01' },
  { label: '봉강폐수처리약품공정(PU-05-02)', value: 'PU-05-02' },
  { label: '이화학시험공정(PU-05-03)', value: 'PU-05-03' },
  { label: '형강암모니아공급공정(PU-05-04)', value: 'PU-05-04' },
  { label: '봉강암모니아공급공정(PU-05-05)', value: 'PU-05-05' },
  { label: '기타용수사용공정(PU-06)', value: 'PU-06' },
  { label: '세륜세척공정(PU-06-01)', value: 'PU-06-01' },
  { label: '이화학시험 및 기타공정(PU-06-02)', value: 'PU-06-02' },
  { label: '공기압축공정(PU-07)', value: 'PU-07' },


  { label: '제강연주공정(P-01)', value: 'P-01' },
  { label: '전기로공정(P-01-01)', value: 'P-01-01' },
  { label: '정련로공정(P-01-02)', value: 'P-01-02' },
  { label: '연주공정(P-01-03)', value: 'P-01-03' },
  { label: '형강제조공정(P-02)', value: 'P-02' },
  { label: '가열로공정(P-02-01)', value: 'P-02-01' },
  { label: '압연공정(P-02-02)', value: 'P-02-02' },
  { label: '정정공정(P-02-03)', value: 'P-02-03' },
  { label: '형강제조공정(P-02)_생산품', value: 'P-02_생산품' },
  { label: '형강제조공정(P-02)_처리', value: 'P-02_처리' },
  { label: '형강제조공정(P-02)_형강류', value: 'P-02_형강류' },
  { label: '형강제조공정(P-02)_판매', value: 'P-02_판매' },
  { label: '봉강제조공정(P-03)', value: 'P-03' },
  { label: '가열로공정(P-03-01)', value: 'P-03-01' },
  { label: '압연공정(P-03-02)', value: 'P-03-02' },
  { label: '원철근공정(P-03-03)', value: 'P-03-03' },
  { label: '원철근공정(P-03-03)_생산품', value: 'P-03-03_생산품' },
  { label: '원철근공정(P-03-03)_처리', value: 'P-03-03_처리' },
  { label: '원철근공정(P-03-03)_원철근', value: 'P-03-03_원철근' },
  { label: '원철근공정(P-03-03)_판매', value: 'P-03-03_판매' },
  { label: '코일철근공정(P-03-04)', value: 'P-03-04' },
  { label: '코일철근공정(P-03-04)_생산품', value: 'P-03-04_생산품' },
  { label: '코일철근공정(P-03-04)_처리', value: 'P-03-04_처리' },
  { label: '코일철근공정(P-03-04)_코일철근', value: 'P-03-04_코일철근' },
  { label: '코일철근공정(P-03-04)_판매', value: 'P-03-04_판매' },

  { label: '형강폐수처리공정(PW-01)', value: 'PW-01' },
  { label: '연주직접수처리공정(PW-01-01)', value: 'PW-01-01' },
  { label: '형강 연주·압연 직접수처리공정(PW-01-02)', value: 'PW-01-02' },
  { label: '형강폐수처리공정(PW-01-03)', value: 'PW-01-03' },
  { label: '봉강폐수처리공정(PW-02)', value: 'PW-02' },
  { label: '봉강압연직접수처리공정(PW-02-01)', value: 'PW-02-01' },
  { label: '봉강폐수처리공정(PW-02-02)', value: 'PW-02-02' },
  { label: '폐기물보관 및 처리공정(PW-03)', value: 'PW-03' },
  { label: '슬러그처리공정(PW-03-01)', value: 'PW-03-01' },
  { label: '분진외폐기물보관공정(PW-03-02)', value: 'PW-03-02' },
  { label: '비점오염원처리공정(PW-04)', value: 'PW-04' },

  { label: '지원설비공정(PE-01)', value: 'PE-01' },
  { label: '전기로 스케일제거공정(PE-01-01)', value: 'PE-01-01' },
  { label: '스카핑공정(PE-01-02)', value: 'PE-01-02' },
  { label: 'Roll 정비공정(PE-01-03)', value: 'PE-01-03' },
  { label: '건닝재 투입공정(PE-01-04)', value: 'PE-01-04' },
  { label: '위험물저장공정(PE-02)', value: 'PE-02' },
  { label: '건조·예열공정(PE-03)', value: 'PE-03' },
  { label: 'Ladle 건조공정(PE-03-01)', value: 'PE-03-01' },
  { label: 'Tundish 건조공정(PE-03-02)', value: 'PE-03-02' },
  { label: 'Ladle 승열공정(PE-03-03)', value: 'PE-03-03' },
  { label: 'Tundish 예열공정(PE-03-04)', value: 'PE-03-04' },
]

export default {
  items,
  getLabel(value) {
    if (items.find(item => item.value === value)) {
      return items.find(item => item.value === value).label || ''
    }

    return ''
  },
  getValue(label) {
    if (items.find(item => item.label === label)) {
      return items.find(item => item.label === label).value || ''
    }
    return ''
  },
  findItems(label) {
    return items.filter(item => item.label.indexOf(label) > -1) || []
  },
  getItemWithLabel(label) {
    if (items.find(item => item.label === label)) {
      return items.find(item => item.label === label) || ''
    }

    return ''
  },
  getItemWithValue(value) {
    if (items.find(item => item.value === value)) {
      return items.find(item => item.value === value) || ''
    }

    return ''
  }
}
